export function normalizeBillingCycle(value) {
  return String(value || '').toLowerCase() === 'annual' ? 'annual' : 'monthly';
}

export function nextPeriodEnd(billingCycle, from = new Date()) {
  const periodEnd = new Date(from);
  if (Number.isNaN(periodEnd.getTime())) {
    throw new TypeError('INVALID_PERIOD_START');
  }

  const originalDay = periodEnd.getUTCDate();
  const originalMonth = periodEnd.getUTCMonth();

  if (normalizeBillingCycle(billingCycle) === 'annual') {
    const targetYear = periodEnd.getUTCFullYear() + 1;
    const lastTargetDay = new Date(Date.UTC(targetYear, originalMonth + 1, 0)).getUTCDate();
    periodEnd.setUTCFullYear(targetYear, originalMonth, Math.min(originalDay, lastTargetDay));
  } else {
    const targetMonthStart = new Date(Date.UTC(
      periodEnd.getUTCFullYear(),
      originalMonth + 1,
      1
    ));
    const targetYear = targetMonthStart.getUTCFullYear();
    const targetMonth = targetMonthStart.getUTCMonth();
    const lastTargetDay = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
    periodEnd.setUTCFullYear(targetYear, targetMonth, Math.min(originalDay, lastTargetDay));
  }

  return periodEnd.toISOString();
}

export function hasActiveTrial(trialRow, now = Date.now()) {
  if (!trialRow) return false;

  const status = String(trialRow.status || '').toLowerCase();
  if (status && status !== 'active') return false;

  const rawEnd =
    trialRow.trial_end ||
    trialRow.trial_ends_at ||
    trialRow.trial_expires_at;
  const end = new Date(rawEnd || '').getTime();

  return Number.isFinite(end) && end > now;
}

export function hasActiveSubscription(subscriptionRow, now = Date.now()) {
  if (!subscriptionRow) return false;
  if (String(subscriptionRow.status || '').toLowerCase() !== 'active') return false;
  const planType = String(subscriptionRow.plan_type || '').toLowerCase();
  // Consultorio (`practice`) is a different SKU. Never treat it as patient Premium.
  if (planType !== 'elite' && planType !== 'premium') return false;

  if (!subscriptionRow.current_period_end) return true;
  const periodEnd = new Date(subscriptionRow.current_period_end).getTime();
  return Number.isFinite(periodEnd) && periodEnd > now;
}

export function resolveEffectiveTier({ subscription, trial, userTrial, now = Date.now() }) {
  if (hasActiveSubscription(subscription, now)) return 'paid';
  if (hasActiveTrial(trial, now) || hasActiveTrial(userTrial, now)) return 'trial';
  return 'basic';
}
